// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination-container[data-v-219acc5b] {\n  margin-top: 0px;\n  padding: 15px 16px;\n}\n.chart-container[data-v-219acc5b] {\n  position: relative;\n  width: 100%;\n  height: calc(100vh - 84px);\n}", ""]);
// Exports
module.exports = exports;
